<template>
	<nav class="navigation-bar">
		<router-link to="/" class="">
			<img :src="sosLogo" class="company-logo" @click="toggleDropdown" />
		</router-link>
		<ul class="navigation-entry-list">
			<li class="navigation-entry-with-dropdown">
				<div @click="toggleDropdown">
					<span id="system-dropdown-entry">{{
						$t('navigation.mainEntries.systemOfSelfPreservation')
					}}</span>
					<img id="system-dropdown-entry-icon" :src="iconExpandDown" />
				</div>
				<ul
					v-if="isDropdownOpen"
					id="system-dropdown"
					class="navigation-dropdown-list"
				>
					<li
						v-for="(entry, index) in entryListForDropdwon"
						:key="index"
						@click="toggleDropdown"
					>
						<router-link-component
							:pathname="entry.pathname"
							:linkText="entry.linkText"
						/>
					</li>
				</ul>
			</li>
			<li
				v-for="(entry, index) in entryListWithoutDropdwon"
				:key="index"
				@click="toggleDropdown"
			>
				<router-link-component
					:pathname="entry.pathname"
					:linkText="entry.linkText"
				/>
			</li>
			<language-selector-entry />
		</ul>
	</nav>
</template>

<script>
import Logo from '@/assets/logo.png'
import IconExpandDown from '@/assets/icons/expand_down.svg'
import RouterLinkComponent from '@/components/RouterLinkComponent.vue'
import LanguageSelectorEntry from '@/components/LanguageSelectorEntry.vue'

export default {
	name: 'Navigation',
	components: {
		RouterLinkComponent,
		LanguageSelectorEntry
	},
	data() {
		return {
			sosLogo: Logo,
			iconExpandDown: IconExpandDown,
			isDropdownOpen: false,
			entryListWithoutDropdwon: [
				{
					pathname: 'Editorial',
					linkText: this.$t('navigation.mainEntries.blog')
				},
				{
					pathname: 'Medien',
					linkText: this.$t('navigation.mainEntries.media')
				},
				{
					pathname: 'Referenzen',
					linkText: this.$t('navigation.mainEntries.references')
				},
				{
					pathname: 'Kontakt',
					linkText: this.$t('navigation.mainEntries.contact')
				}
			],
			entryListForDropdwon: [
				{
					pathname: 'DasSystem',
					linkText: this.$t('navigation.mainEntries.theSystem')
				},
				{
					pathname: 'Aufbau',
					linkText: this.$t('navigation.mainEntries.structure')
				},
				{
					pathname: 'Ausbildungsgrade',
					linkText: this.$t('navigation.mainEntries.trainingContent')
				},
				{
					pathname: 'Ausbilder',
					linkText: this.$t('navigation.mainEntries.trainer')
				}
			]
		}
	},

	i18n: {
		messages: {
			de: require('@/i18n/de/de_navigation.json'),
			en: require('@/i18n/en/eng_navigation.json')
		}
	},
	methods: {
		toggleDropdown() {
			this.isDropdownOpen = !this.isDropdownOpen
		},

		handleOutsideClick(ev) {
			if (document.getElementById('system-dropdown')) {
				if (
					ev &&
					ev.target &&
					ev.target.id !== 'system-dropdown-entry' &&
					ev.target.id !== 'system-dropdown-entry-icon' &&
					ev.target.id !== 'system-dropdown'
				) {
					this.toggleDropdown()
				}
			}
		}
	},
	mounted() {
		document.addEventListener('click', this.handleOutsideClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleOutsideClick)
	}
}
</script>

<style scoped lang="stylus">
.navigation-bar {
	background-color: #000;
	font-family: 'Red Hat Display', sans-serif;
	display: flex;
	justify-content: space-between;
	padding: 10px 40px 8px 22px;
	width: 100%;
	position: fixed;
    top: 0;
    z-index: 1;
	font-size: 14px;
}
.company-logo {
	width: 100%;
	max-width: 200px;
}
.navigation-entry-list, .navigation-entry-list ul {
	list-style-type: none;
	margin: 0;
}
.navigation-entry-list {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100vw - 42vw);
}
.navigation-entry-with-dropdown {
	position: relative;
}
.navigation-dropdown-list {
	position: absolute;
	background-color: #000;
	width: 100%;
	top: 45px;
	padding-left: 10px;
	border-top: solid red 1px;
}
.navigation-dropdown-list > li {
	margin: 20px 0px;
}
.navigation-entry-with-dropdown div {
	display: flex;
	align-items: center;
	cursor: pointer;
}
</style>
